<template>
  <div class="container"></div>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useAuthStore } from '@/stores/authStore'
import { useUserStore } from '@/stores/userStore'
import { useStageStore } from '@/stores/stageStore'

export default {
  name: 'SsoView',
  data() {
    return {
      loading: false,
      stageNotFound: false,
      hostname: ''
    }
  },
  computed: {
    ...mapState(useAuthStore, ['authData']),
    ...mapState(useStageStore, ['stageConfigs'])
  },
  async created() {
    this.loading = true

    // 1. GET USER & STAGE CONFIGS DATA
    await this.getUserData()
    await this.getStageConfigs()

    // 2. DESTRUCTURING route query & authData
    const { fqdn, path, lang, ...additional } = this.$route.query
    const { refresh_token, token } = this.authData

    // 3. FIND STAGE WITH stage_id
    const stage = this.stageConfigs.find((item) => {
      return item.stage.fqdn === fqdn
    })
    // 4. If stage exists, redirect to

    if (stage) {
      let stageHostname =
        import.meta.env.VITE_ENV === 'dev' &&
        import.meta.env.VITE_PANEL_URL_PORT !== ''
          ? stage.stage.fqdn.replace(
              'picout.local',
              `picout.local:${import.meta.env.VITE_PANEL_URL_PORT}`
            )
          : stage.stage.fqdn

      const additionalQuery = additional || {}

      const mergedQuery = {
        ...additionalQuery,
        rt: refresh_token,
        t: token,
        l: lang
      }

      let stageUrl = `${import.meta.env.VITE_PANEL_URL_SCHEME}://${stageHostname}${path}?${new URLSearchParams(mergedQuery).toString()}`

      this.hostname = stageUrl

      window.location.replace(stageUrl)
    } else {
      this.stageNotFound = true
      this.$router.push({ name: 'NotFoundView' })
    }

    this.loading = false
  },

  methods: {
    ...mapActions(useUserStore, ['getUserData']),
    ...mapActions(useStageStore, ['getStageConfigs'])
  }
}
</script>
